{
  "dismiss": "무시"
}
